

define(['angular', 'squid/index', 'components/xo-models/src/checkout/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-done', ['squid', 'xo-done.directive']).factory('$DoneRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('DoneRoute', {
            name: 'done',
            directive: 'xo-done',
            titleContent: 'done.paymentCompleted',
            query: ['code'],
            trackingData: {
                fptiState: 'done_page',
                templateName: 'memberDone.dust',
                pageGoal: 'Payment Done Receipt',
                trackStateExit: true,
                buzname: {
                    'fullpage': {
                        'pagename': '%::fullpage-done',
                        'pagename2': '%::fullpage-done:member:hermes:',
                        'version': 'member:%:'
                    }
                }
            },
            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/done/route.js
// module id = ./components/xo-page-components/src/done/route.js
// module chunks = 1